<template>

  <el-row class="footer-wrapper">
    <el-col :span="24">
      <el-row :gutter="30">
        <el-col :span="24" class="footer-top-wrapper" style="display: flex; flex-direction: row">
          <el-col :span="6" style="display: flex; flex-direction: row; justify-content: flex-start">
            <div class="footer-logo">
              <img
                alt=""
                class="unifi-logo-svg cursor-pointer"
                src="../../assets/unifi-logo-new-with-text-white.svg"
                style="height:48px;margin-bottom:29px;"
                @click="redirectToHome"
              />

            </div>
          </el-col>
          <el-col :span="12" style="display:flex; justify-content: center; align-items: center">
              <span class="footerText" style="margin-top: 6.5px; padding-right: 10px;"
              >{{ "\u00A9 " + new Date().getFullYear() }} UNIFI Property, All rights reserved
              </span>
            <div style=" padding-right: 10px; width: 30px; height: 30px;">
              <a href="https://www.facebook.com/unifiproperty" target="_blank">
                <img style="object-fit: cover; width: 100%; height: 100%;" alt="Facebook" src="../../../static/img/facebook48x48.png"/>
              </a>
            </div>
            <div style="padding-right: 10px; width: 30px; height: 30px;">
              <a href="https://www.instagram.com/unifiproperty/" target="_blank">
                <img style="object-fit: cover; width: 100%; height: 100%;" alt="Intagram" src="../../../static/img/instagram48x48.png"/>
              </a>
            </div>
          </el-col>
          <el-col :span="6"  style="display: flex; flex-direction: row; justify-content: flex-end; align-items: center">
            <span class="footer-state-btn" @click="openPrivacyPolicy">Privacy Policy</span>
            <span class="footer-state-btn" @click="openTnC">Terms &amp; Conditions</span>
          </el-col>
<!--          <el-col :span="12" style="display: flex; flex-direction: row">-->
<!--            <el-col :span="8">Find your property</el-col>-->
<!--            <el-col :span="8">Info</el-col>-->
<!--            <el-col :span="8">Location</el-col>-->
<!--          </el-col>-->
<!--          <el-col :span="6" style="display: flex; flex-direction: row; justify-content: flex-end">-->
<!--            <el-row :span="24" style="display: flex; flex-direction: row; padding-bottom: 2%">-->

<!--              <unifi-button v-if="!isSignedIn && !privateMode" label="Login" class-name="btn-primary"  @onClick="redirectToLogin" ></unifi-button>-->

<!--&lt;!&ndash;              <unifi-button v-if="!isSignedIn && !privateMode" label="Join" class-name="btn-default"  @onClick="" style="padding-left: 20px"></unifi-button>&ndash;&gt;-->
<!--            </el-row>-->
<!--          </el-col>-->
        </el-col>
      </el-row>
      <el-row :gutter="30">
        <el-col :span="24" class="footer-bottom-wrapper">
<!--          <el-col :span="6" class="footer-btm-txt-wrapper">-->
<!--            <el-row>-->
<!--              <el-col :span="24" class="footer-btm-txt" >Buy Tomorrow’s</el-col>-->
<!--              <el-col :span="24" class="footer-btm-txt">Real Estate...</el-col>-->
<!--              <el-col :span="24" class="footer-btm-txt">Today</el-col>-->
<!--            </el-row>-->

<!--            &lt;!&ndash;            <span>Find your new Property and reserve it today</span>&ndash;&gt;-->
<!--          </el-col>-->
          <el-col :span="12">
<!--            <el-col :span="8" class="footer-states-wrapper"-->
<!--                    style="display: flex; flex-direction: column; justify-content: flex-start">-->

<!--              <span v-if="isUConnectSignIn && !privateMode" class="footer-state-btn" @click="changePropertyType('buy')">Buy</span>-->
<!--              <span v-if="isUConnectSignIn && !privateMode" class="footer-state-btn" @click="changePropertyType('sold')">Sold</span>-->
<!--              <span class="footer-state-btn" @click="redirectToBlog">Blog</span>-->
<!--              <span class="footer-state-btn"> &nbsp; </span> &lt;!&ndash;can be deleted after adding the News column span, this span added because if the column is empty column will collapse&ndash;&gt;-->
<!--            </el-col>-->
            <el-col :span="8">
              <el-row class="footer-states-wrapper" style="display: flex; flex-direction: column">
                <!--                <span class="footer-state-btn">Our agents</span>-->
<!--                <span v-if="!privateMode"  class="footer-state-btn" @click="redirectToAboutUs">About us</span>-->
<!--                <span v-if="!privateMode" class="footer-state-btn" @click="redirectToHowItWorks">How it works</span>-->
<!--                <span v-if="!privateMode" class="footer-state-btn" @click="redirectToContactUs">Contact us</span>-->
<!--                <span v-if="!privateMode" class="footer-state-btn" @click="openPrivacyPolicy">Privacy Policy</span>-->
<!--                <span v-if="!privateMode" class="footer-state-btn" @click="openTnC">Terms &amp; Conditions</span>-->
              </el-row>
            </el-col>
<!--            <el-col :span="8">-->
<!--              <div v-if="isUConnectSignIn && !privateMode" class="footer-states-wrapper">-->
<!--                <span v-if="states.includes('New South Wales')" class="footer-state-btn" @click="changeState('New South Wales')">NSW</span>-->
<!--                <span v-if="states.includes('Australian Capital Territory')" class="footer-state-btn" @click="changeState('Australian Capital Territory')">ACT</span>-->
<!--                <span v-if="states.includes('Queensland')" class="footer-state-btn" @click="changeState('Queensland')">QLD</span>-->
<!--                <span v-if="states.includes('Western Australia')" class="footer-state-btn"  @click="changeState('Western Australia')">WA</span>-->
<!--                <span v-if="states.includes('Northern Territory')" class="footer-state-btn" @click="changeState('Northern Territory')">NT</span>-->
<!--                <span v-if="states.includes('Victoria')" class="footer-state-btn" @click="changeState('Victoria')">VIC</span>-->
<!--                <span v-if="states.includes('Tasmania')" class="footer-state-btn" @click="changeState('Tasmania')">TAS</span>-->
<!--                <span v-if="states.includes('South Australia')" class="footer-state-btn" @click="changeState('South Australia')">SA</span>-->

<!--              </div>-->
<!--            </el-col>-->
          </el-col>
        </el-col>
      </el-row>
<!--      <el-row :gutter="30">-->
<!--        <el-col :span="24" >-->
<!--          <el-row :gutter="20" style="width: 100%; height: 20px;">-->

<!--            <el-col :offset="6" :span="12" style="display:flex; justify-content: center">-->
<!--              <span class="footerText" style="margin-top: 6.5px; padding-right: 10px;"-->
<!--                    >{{ "\u00A9 " + new Date().getFullYear() }} UNIFI Property, All rights reserved-->
<!--              </span>-->
<!--              <div style=" padding-right: 10px; width: 30px; height: 30px;">-->
<!--                <a href="https://www.facebook.com/unifiproperty" target="_blank">-->
<!--                  <img style="object-fit: cover; width: 100%; height: 100%;" alt="Facebook" src="../../../static/img/facebook48x48.png"/>-->
<!--                </a>-->
<!--              </div>-->
<!--              <div style="padding-right: 10px; width: 30px; height: 30px;">-->
<!--                <a href="https://www.instagram.com/unifiproperty/" target="_blank">-->
<!--                  <img style="object-fit: cover; width: 100%; height: 100%;" alt="Intagram" src="../../../static/img/instagram48x48.png"/>-->
<!--                </a>-->
<!--              </div>-->
<!--            </el-col>-->
<!--            <el-col :span="6" style="display: flex; flex-direction: row; align-self: flex-end; justify-content: space-between">-->

<!--            </el-col>-->
<!--          </el-row>-->
<!--        </el-col>-->
<!--      </el-row>-->
    </el-col>
  </el-row>

</template>

<script>
import {mapState, mapActions} from 'vuex'
import UnifiButton from "../common/unifiButton.vue";
import {mobileApp} from "../utils/utils";

export default {
  components: {UnifiButton},
  inject: ['reload'],

  data() {
    return {
      excludePaths:['/uConnectLogin','/login', '/privatelogin', '/how-it-works', '/about','/contactus', '/terms-and-conditions', '/blog', 'privacy-policy',  '/uConnectRegister'],
      isSignedIn: false,
      link: '',
      contactEmail: '',
      contactNumber: '',
      socialInstagram: '',
      socialTwitter: '',
      socialFacebook: '',
      states: [],
      availableStates: [],
      tenant: window.location.hostname.replace("www.", '').split('.')[0].split("unifiproperty")[0].split("platform")[0],
      searchFiltersForm: {
        sort: "time",
        saleType: "1",
        propertyTypeList: ["All"],
        minPrice: "Any",
        maxPrice: "Any",
        minRentalEstimate: "Any",
        maxRentalEstimate: "Any",
        minLandSize: "Any",
        maxLandSize: "Any",
        minBuildSize: "Any",
        maxBuildSize: "Any",
        minBedrooms: "Any",
        maxBedrooms: "Any",
        bathrooms: "Any",
        carSpaces: "Any",
        searchSuburb: ""
      },
      selectedState:"",
      selectedPropertyType:"buy",
    }
  },
  props: {
    showQus: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    isUConnectSignIn: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    privateMode: Boolean,
    default: () => {
      return false
    }
  },
  created() {
    if (!this.privateMode) {
      if(!this.excludePaths.includes(this.$route.path)){
        console.log("not excluded Path")
        // this.getAgentName({callback: this.signInCheckCallback});
      }
    }
  },
  methods: {
    ...mapActions('account', [
      'getUserDtl'
    ]),
    ...mapActions('contact', [
      'getList'
    ]),
    ...mapActions('social', [
      'getSocial'
    ]),
    ...mapActions(["getAgentName"]),
    ...mapActions(["getAllStates"]),
    redirectToContactUs() {
      this.$router.push({path: '/contactus'})
    },
    redirectToLogin() {
      // if (this.isUConnectSignIn) {
      //   if (this.$route.path !== "/uConnectLogin") {
      //     this.$router.push({path: "/uConnectLogin"});
      //   } else {
      //     this.reload();
      //   }
      // } else {
      //   if (this.$route.path !== "/login") {
      //     this.$router.push({path: "/login"});
      //   } else {
      //     this.reload();
      //   }
      // }

      if (this.$route.path !== "/login") {
        this.$router.push({path: "/login"});
      } else {
        this.reload();
      }
    },
    // redirectToRegistration() {
    //   this.$router.push({path: "/register"});
    // },

    redirectToHome() {
      console.log("this.reload")
      var that = this
      if(!this.privateMode) {
        if (that.$route.path !== '/') {
          if(that.isUConnectSignIn) {
            that.$router.push('/uconnect/search/results')
          } else {
            that.$router.push('/dashboard')
          }
        } else {
          that.reload()
        }
      }

      // this.$router.push({path: '/'})
    },
    redirectToAboutUs() {
      this.$router.push({path: "/about"});
    },
    redirectToHowItWorks() {
      this.$router.push({path: "/how-it-works"});
    },
    openPrivacyPolicy() {
      // if (this.$route.path !== "/privacy-policy") {
      //   this.$router.push("/privacy-policy");
      // } else {
      //   this.reload();
      // }
      window.open("https://s3.ap-southeast-2.amazonaws.com/com.unifiproperty/docs/privacy-policy/UNIFI-Property-Privacy-Policy.pdf", "_blank");
    },
    openTnC() {
      // if (this.$route.path !== "/terms-and-conditions") {
      //   this.$router.push("/terms-and-conditions");
      // } else {
      //   this.reload();
      // }
      window.open("https://s3.ap-southeast-2.amazonaws.com/com.unifiproperty/docs/terms-and-conditions/UNIFI-Property-Terms-and-Conditions.pdf", "_blank");
    },
    redirectToBlog() {
      this.$router.push({path: "/blog"});
    },
    signInCheckCallback(res) {
      var that = this;
      if (res.code == 0) {
        if (res.data != null) {
          that.isSignedIn = true;
        }
      } else if (res.code == 90000 || res.code == 90002) {

      } else if (res.data.code == 8902 || res.code == 8901) {
      }
    },

    getAllStatesCallback(res) {
      var that = this;
      if (res.code == 0) {
        this.availableStates = res.data;
        for(let state of this.availableStates){
          this.states.push(state);
        }

      } else {

      }
    },
    changeState(state) {
      this.selectedState = state;
      this.goToQuickSearch();
    },
    changePropertyType(propertyType) {
      this.selectedPropertyType = propertyType;
      this.goToQuickSearch();
    },
    goToQuickSearch() {
      //get for SA only for now, and fix up post go live

      let options = sessionStorage.searchFiltersForm
        ? JSON.parse(sessionStorage.searchFiltersForm)
        : this.searchFiltersForm;

      console.log("this.searchType: ", this.searchType);

      // this.searchFiltersForm.searchType = this.searchType
      if (this.searchFiltersForm.searchSuburb) {
        this.searchFiltersForm.searchSuburb = this.searchFiltersForm.searchSuburb.replace(
          " SA, Australia",
          ""
        );
      }
      //set search Property Type
      if(this.selectedPropertyType === 'sold'){
        options.searchType = "sold";
      }else{
        options.searchType = "buy";
      }

      //set search State
      switch (this.selectedState) {
        case "New South Wales":
          options.searchSuburb = "New South Wales";
          break;
        case "Queensland":
          options.searchSuburb = "Queensland";
          break;
        case "Victoria":
          options.searchSuburb = "Victoria";
          break;
        case "Australian Capital Territory":
          options.searchSuburb = "Australian Capital Territory";
          break;
        case "South Australia":
          options.searchSuburb = "South Australia";
          break;
        case "Western Australia":
          options.searchSuburb = "Western Australia";
          break;
        case "Tasmania":
          options.searchSuburb = "Tasmania";
          break;
        case "Northern Territory":
          options.searchSuburb = "Northern Territory";
          break;
        default:
          options.searchSuburb = "Australia";
          break;
      }

      this.searchFiltersForm= options;

      sessionStorage.setItem("isSearch", "1");
      sessionStorage.setItem(
        "searchFiltersForm",
        JSON.stringify(this.searchFiltersForm)
      );
      if (this.$route.path !== "/uconnect/search/results") {
        this.$router.push("/uconnect/search/results");
      } else {
        this.$router.go();
      }
    },
    userCallback(res) {
      var that = this
      if (res.data.code == 0) {
        console.log("############ footer usercallback")
        sessionStorage.removeItem('a')
        sessionStorage.removeItem('b')
        sessionStorage.removeItem('c')
        sessionStorage.removeItem('d')
        sessionStorage.setItem('a', res.data.data.email)
        sessionStorage.setItem('b', res.data.data.phoneNumber)
        sessionStorage.setItem('c', res.data.data.mobileNumber)
        sessionStorage.setItem('d', res.data.data.firstName + ' ' + res.data.data.lastName)
        /*if (res.data.data.mobileNumber.slice(0,1) !== '0') {
            res.data.data.mobileNumber = '0' + res.data.data.mobileNumber
        }*/
        that.link = 'mailto:' + this.contactEmail + '?subject=<Submit Request Form>&body=Referrer’s name: ' + res.data.data.firstName + ' ' + res.data.data.lastName +
          '%0d%0a' + 'Referrer’s email address: ' + res.data.data.email +
          '%0d%0a' + 'Referrer’s contact number: ' + res.data.data.phoneNumber +
          '%0d%0a' + 'Referrer’s mobile number: ' + res.data.data.mobileNumber +
          '%0d%0a' + '========================================' +
          '%0d%0a' + 'PLEASE ENTER THE PROPERTY DETAILS BELOW AS APPLICABLE:' +
          '%0d%0a' + 'Desired Suburb(s):' +
          '%0d%0a' + 'Total Budget: $' +
          '%0d%0a' + 'Land Size:' +
          '%0d%0a' + 'Land Frontage:' +
          '%0d%0a' + 'No. of Bedrooms:' +
          '%0d%0a' + 'No. of Bathrooms:' +
          '%0d%0a' + 'Garage:' +
          '%0d%0a' + 'No. of Living Areas:' +
          '%0d%0a' + 'Single/Double Story:' +
          '%0d%0a' + 'Alfresco (Yes/No):' +
          '%0d%0a' + 'Additional Notes:' +
          '%0d%0a' + 'Thank you for submitting your request. A UNIFI representative will review your request and be in touch within the next 24 - 48 hours.' +
          ' %0d%0a '
        that.link = that.link.replace(' UNIFI ', ' ' + that.tenant.toUpperCase() + ' ')
      } else if (res.data.code == 90000 || res.data.code == 90002 || res.data.code == 90001) {
        // localStorage.clear()
        // that.$router.push('/login')
      } else if (res.data.code == 8902 || res.data.code == 8901) {
        that.$box.alert('', res.data.message, 'error')
        // localStorage.clear()
        // that.$router.push('/login')
      } else {
        that.$box.alert('', res.data.message, 'error')
      }
    },

    contactCallback(res) {
      var that = this
      if (res.data.code == 0) {
        this.contactEmail = res.data.data.contactEmail
        this.contactNumber = res.data.data.contactPhone
      } else if (res.data.code == 90000 || res.data.code == 90002 || res.data.code == 90001) {
        // localStorage.clear()
        // that.$router.push('/login')
      } else if (res.data.code == 8902 || res.data.code == 8901) {
        that.$box.alert('', res.data.message, 'error')
        // localStorage.clear()
        // that.$router.push('/login')
      } else {
        that.$box.alert('', res.data.message, 'error')
      }
      that.getUserDtl({callback: that.userCallback})
    },

    socialCallback(res) {
      var that = this
      if (res.data.code == 0) {
        this.socialInstagram = res.data.data.socialInstagram
        this.socialTwitter = res.data.data.socialTwitter
        this.socialFacebook = res.data.data.socialFacebook
      } else if (res.data.code == 90000 || res.data.code == 90002 || res.data.code == 90001) {
        // localStorage.clear()
        // that.$router.push('/login')
      } else if (res.data.code == 8902 || res.data.code == 8901) {
        that.$box.alert('', res.data.message, 'error')
        // localStorage.clear()
        // that.$router.push('/login')
      } else {
        that.$box.alert('', res.data.message, 'error')
      }
      that.getUserDtl({callback: that.userCallback})
    },


    toMain() {
      var that = this
      if (that.$route.path !== '/') {
        that.$router.push('/')
      }
    },
    evt() {
      var v = this.urlLst.find((v) => {
        if (v.type == 1) {
          return v
        }
      })
      if (v) {
        window.open(v.url, '_blank')
      }
    },
    edu() {
      var v = this.urlLst.find((v) => {
        if (v.type == 2) {
          return v
        }
      })
      if (v) {
        window.open(v.url, '_blank')
      }
    },
    refresh(path) {
      if (path == this.$route.path) {
        location.reload()
      }
    },
    openAppStore() {
      window.open(this.mobileApp.ios, '_blank')
    },
    openPlayStore() {
      window.open(this.mobileApp.android, '_blank')
    }
  },
  computed: {
    // ...mapState({
    //   urlLst: state => state.login.url
    // })
    mobileApp() {
      return mobileApp
    }
  }
}
</script>

<style lang="scss" scoped>
.footer-wrapper {
  width: 100%;
  min-height: 3%;
  min-width: 1200px;
  padding: 1%;
  background: #003333;
  z-index: 1000;
  display: flex;
  flex-direction: row;
  font: 400 16px/125% DINosaur-a, sans-serif;
  color: #fff;

  .footer-bottom-wrapper {
    .footer-btm-text-wrapper {
      font-weight: 400;
    }
  }
  .footer-btm-txt {
    font-size: 3.19vw;
    line-height: 3.19vw;
  }
  .footer-states-wrapper {
    height: 10%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }

  .footer-state-btn {
    background: transparent;
    border-color: transparent;
    cursor: pointer;
    color: #fff;
    width: 50%;
  }
  .footer-end-wrapper {
    display: flex;
    justify-content: flex-end
  }
}

.fotTxt {
  width: 100%;
  height: 317px;
  background-size: cover;
  background-position: center top;
  background-repeat: no-repeat;
  color: #fff;

  h1 {
    font-size: 26px;
    padding-top: 58px;
    margin-bottom: 18px;
    text-align: center;
  }

  h2 {
    font-size: 16px;
    line-height: 30px;
    margin-bottom: 30px;
    text-align: center;
  }

  .link {
    display: block;
    border: none;
    margin: 0 auto;
    cursor: pointer;
    width: 180px;
    height: 52px;
    background: rgba(44, 202, 115, 1);
    border-radius: 6px;
    text-align: center;
    line-height: 52px;
    font-size: 15px;
    color: #fff;
    text-decoration: none;
  }
}

.fotCon {
  width: 1180px;
  margin: 0 auto;
  color: #fff;
  padding-top: 46px;

  .top {
    padding-bottom: 46px;
    border-bottom: 1px solid #3f3f46;
    margin-bottom: 47px;
  }

  .logo {
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    float: left;
    cursor: pointer;
  }

  .share {
    float: right;

    .ins {
      display: block;
      width: 38px;
      height: 38px;
      background-size: contain;
      background-position: center center;
      background-repeat: no-repeat;
      float: right;
      cursor: pointer;
      margin-right: 20px;
    }

    .twitter {
      display: block;
      width: 38px;
      height: 38px;
      background-size: contain;
      background-position: center center;
      background-repeat: no-repeat;
      float: right;
      cursor: pointer;
    }

    .facebook {
      display: block;
      width: 38px;
      height: 38px;
      background-size: contain;
      background-position: center center;
      background-repeat: no-repeat;
      float: right;
      margin-right: 20px;
      cursor: pointer;
    }
  }

  .bottom {
    text-align: center;

    ul {
      display: inline-block;
      font-size: 16px;
      color: #111111;
      margin-bottom: 107px;

      li {
        margin-right: 70px;
        float: left;
        cursor: pointer;

        a {
          color: #111111;
          text-decoration: none;
        }
      }

      li:nth-last-child(1) {
        margin: 0;
      }
    }

    p {
      padding-bottom: 39px;
      line-height: 14px;
      font-size: 12px;
      color: #3f3f46;
      text-align: center;
      text-decoration: underline;
      cursor: pointer;

      span {
        display: inline-block;
        margin: 0 12px;
        text-decoration: none;
      }

      i {
        font-style: normal;
      }

      strong {
        font-weight: normal;
      }
    }
  }
}

.unifi-logo-svg {
  fill: #fff;
  font-family: DINosaur-a, sans-serif;
}

.bg-setting {
  background-color: #101010;
}

.cursor-pointer {
  cursor: pointer;
}

a {
  text-decoration: none;
  color: #fff;
}

a.underlined {
  text-decoration: underline;
}
.download-txt {
  color: #003333;
  background-color: #ffffff;
  padding: 20px 50px 20px 50px;
  border-radius: 5px;
  font-size: 30px;
}
.cursor-p {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/package/footer.vue